import { useState, useEffect } from 'react';
import { useImageLoad } from '~/utils/image-load-provider';

/**
 * Source: https://stackoverflow.com/a/73583867/4230039
 */
export const useContainerDimensions = (
  containerRef: React.RefObject<HTMLDivElement>
) => {
  const getDimensions = () => ({
    width: containerRef.current?.offsetWidth || 0,
    height: containerRef.current?.offsetHeight || 0,
    scrollHeight: containerRef.current?.scrollHeight || 0,
    top: containerRef.current?.offsetTop || 0,
    scroll: containerRef.current?.scrollTop || 0,
    windowTop: typeof window !== 'undefined' ? window.scrollY : 0,
  });

  const [dimensions, setDimensions] = useState({
    width: 0,
    height: 0,
    scrollHeight: 0,
    top: 0,
    scroll: 0,
    windowTop: 0,
  });

  const { imagesLoaded } = useImageLoad();

  useEffect(() => {
    const handleResize = () => {
      setDimensions(getDimensions());
    };

    let dimensionsTimeout = setTimeout(() => {
      if (containerRef.current) {
        setDimensions(getDimensions());
      }
    }, 100);

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize);
    }

    return () => {
      clearTimeout(dimensionsTimeout);
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [containerRef, imagesLoaded]);

  return dimensions;
};
